export default __webpack_public_path__ + "2309f792a7455e1c95741c31300a4f40.png";